/* EVANNY WORLD CLASS — progressive motion + welcome experience.
   Motion is progressive enhancement; the welcome layer is injected after first paint
   so it does not block LCP or the native Shopify storefront runtime. */
(function(){
  'use strict';

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  if(reduce&&reduce.matches){
    document.documentElement.classList.add('ev-motion-reduced');
    return;
  }

  var observer;
  var selector='#MainContent > .shopify-section';

  function mark(section){
    if(!section||section.dataset.evMotion==='1') return;
    section.dataset.evMotion='1';

    if(section.querySelector('[data-ev-mobile-buybar]')){
      section.classList.remove('ev-reveal');
      section.classList.add('is-visible');
      return;
    }

    var rect=section.getBoundingClientRect();
    var belowInitialViewport=rect.top>window.innerHeight*0.82;
    if(!belowInitialViewport){
      section.classList.add('is-visible');
      return;
    }

    section.classList.add('ev-reveal');
    observer.observe(section);
  }

  function init(){
    observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        var node=entry.target;
        requestAnimationFrame(function(){node.classList.add('is-visible');});
        observer.unobserve(node);
      });
    },{root:null,rootMargin:'0px 0px -10% 0px',threshold:0.06});

    document.querySelectorAll(selector).forEach(mark);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();

  document.addEventListener('shopify:section:load',function(event){
    if(!observer) return;
    var section=event.target&&event.target.closest?event.target.closest('.shopify-section'):null;
    if(section&&section.parentElement&&section.parentElement.id==='MainContent') mark(section);
  });
})();
